module.exports = __webpack_public_path__ + "static/media/Doklad_Oditen_komitet_22.05.2018.9f010f6d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Doklad_Oditen_komitet_22.05.2018.pdf
// module id = 139
// module chunks = 0